export default __webpack_public_path__ + "static/media/ic-factory.9ca151ef.svg";